import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { NoData, Loading, Sorting, DataTable } from 'components/layouts';
import { Heading } from 'components/styled/ui';
import { connect } from 'react-redux';
import { media } from 'components/styled/utils';
import { strings } from 'config';

class DataList extends Component {
  getFiltersResult = data => {
    return <ul>{data.map((val, index) => <li key={index}>{val.label}</li>)}</ul>;
  };

  onSortChange = val => {
    this.props.onSortValChange(val);
  };

  renderSearchTitles() {
    const { filters } = this.props;
    const { search, municipality } = filters;
    const selectedLangugage = strings.getLanguage();

    if (search && municipality.name !== 'सबै स्थानिय सरकारहरु') {
      if (selectedLangugage === 'np') {
        return (
          <Heading.h3 className="h3">
            "{search}"
            {municipality.name && <Fragment> का लागि {municipality.name}मा नतिजा</Fragment>}
          </Heading.h3>
        );
      } else {
        return (
          <Heading.h3 className="h3">
            Search results for "{search}"
            {municipality.name && <Fragment> in {municipality.nameEn}</Fragment>}
          </Heading.h3>
        );
      }
    } else if (search) {
      if (selectedLangugage === 'np') {
        return <Heading.h3 className="h3">"{search}" का लागि नतिजा </Heading.h3>;
      } else {
        return <Heading.h3 className="h3">Search results for "{search}"</Heading.h3>;
      }
    } else if (municipality.name !== 'सबै स्थानिय सरकारहरु') {
      if (municipality.name) {
        if (selectedLangugage === 'np') {
          return <Heading.h3 className="h3">{municipality.name}का कागजातहरू </Heading.h3>;
        } else {
          return <Heading.h3 className="h3"> Search results in {municipality.nameEn}</Heading.h3>;
        }
      }
      return <Heading.h3 className="h3">{strings.dataListHeader.title}</Heading.h3>;
    } else {
      return <Heading.h3 className="h3">{strings.dataListHeader.title}</Heading.h3>;
    }
  }

  renderHeader() {
    const { data } = this.props;

    return (
      <Header className="with-sort">
        {this.renderSearchTitles()}
        {data && data.length > 0 && <Sorting />}
      </Header>
    );
  }

  renderList() {
    const { data } = this.props;

    if (data && data.length) {
      return <DataTable data={data} />;
    } else {
      return <NoData />;
    }
  }

  render() {
    const { fetching } = this.props;

    return (
      <Fragment>
        {this.renderHeader()}

        {fetching ? <Loading page="home" /> : this.renderList()}
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  fetching: state.datahub.fetching,
  filters: state.filters
});

export default withRouter(connect(mapStateToProps)(DataList));

const Header = styled.div`
  padding: 20px 20px 36px 20px;

  ${media.sm`
    padding: 30px 40px 30px 40px; 
  `};

  h3 {
    line-height: 1.3;
  }

  &.with-sort {
    display: flex;
    flex-direction: column;

    ${media.xs`
    justify-content: space-between;
      align-items: center;
      flex-direction: row;
    `};
  }

  &.with-filters {
    h3 {
      margin-bottom: 18px;
    }

    .filtered-list {
      margin-bottom: 8px;
      span {
        color: rgba(74, 74, 74, 0.5);
      }
      > ul {
        display: inline-block;

        > li {
          display: inline-block;
          font-size: ${props => props.theme.fontSize.sm};
          color: ${props => props.theme.primary.raatri};
          &:not(:last-child) {
            &:after {
              content: ',';
              margin-right: 4px;
            }
          }
        }
      }
    }
  }

  .sort-options {
    > span:first-child {
      margin-right: 8px;
    }
  }

  h3 {
    @media screen and (max-width: 480px) {
      font-size: 18px;
      margin-bottom: 12px;
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/layouts/dataList/dataList.js